import { IStampable } from "../../../types/Floorplan.types";

export interface IDeskCanvasControlsProps {
    doors: IStampable[];
    selectedDoorIdx?: number;
}

const DoorCanvasControls = (props: IDeskCanvasControlsProps) => {
    const { doors, selectedDoorIdx } = props;
    if (selectedDoorIdx !== undefined) {
        return (
            <svg id="doorControlHandles" x={doors[selectedDoorIdx].x+10} y={doors[selectedDoorIdx].y+12.5} overflow="visible">
                <g transform={`rotate(${doors[selectedDoorIdx].rotation})`}>
                    <path d="m-10,-10 l20,0 l0,20 l-20,0 z" stroke="#b7b7b7" strokeDasharray="4" fill="none" />
                    <circle id="doorRotationHandle" cx="10" cy="-10" r="2" stroke="#999" strokeWidth="0.5" fill="white" />
                </g>
            </svg>
        );
    }
    return null;
};

export default DoorCanvasControls;